import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IFileExtend } from "../../model/IFileExtend";

@Injectable({
  providedIn: "root",
})

export class GroupClaimSubmissionService {

  routePrefix = "/api/GCSubmission";
  requestTokenKey = 'requestToken';
  requestToken: string;

  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  clearRequestToken() {
    sessionStorage.removeItem(this.requestTokenKey);
  }

  add(data): Observable<any> {
    return this.http.post(this.routePrefix + "/add", data, { headers: this.getRequestTokenHeader() });
  }

  addPpoSubmission(data: FormData) {
    return this.http.post(`${this.routePrefix}/add-ppo-submission`,data);
  }

  getPpoClaimDocuments(productId: number) {
    return this.http.get(`${this.routePrefix}/ppo-documents/${productId}`);
  }

  additionalDocumentSubmission(data): Observable<any> {
    return this.http.post(
      this.routePrefix + "/additionalDocumentSubmission",
      data,
      { headers: this.getRequestTokenHeader() }
    );
  }

  getClaimDocuments(productId: number, securityToken: string): Observable<any> {
    const body = {
      productId: productId,
      securityToken: securityToken
    };
    return this.http.post(this.routePrefix + "/document", body, { headers: this.getRequestTokenHeader() });
  }

  getNigoDocumnetByClaimEntryId(
    claimEntryId: number,
    securityToken: string,
    enrolId: number): Observable<any> {

    const body = {
      claimEntryId: claimEntryId,
      securityToken: securityToken,
      enrolId: enrolId
    };

    return this.http.post(this.routePrefix + "/getNigoDocumnetByClaimEntryId", body, { headers: this.getRequestTokenHeader() });
  }

  getClaimInformation(
    claimEntryId: number,
    securityToken: string
  ): Observable<any> {

    const body = {
      claimEntryId: claimEntryId,
      securityToken: securityToken
    };

    return this.http.post(this.routePrefix + "/getClaimInformation", body, { headers: this.getRequestTokenHeader() });
  }

  claimFormDocument(productId: number, securityToken: string): Observable<any> {
    const body = {
      productId: productId,
      securityToken: securityToken
    };
    return this.http.post(this.routePrefix + "/claimFormDocument", body, { headers: this.getRequestTokenHeader() });
  }

  claimReport(data: any): Observable<any> {
    return this.http
      .post(this.routePrefix + "/claimreport", data, { responseType: "blob", headers: this.getRequestTokenHeader() })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getClaimSubmissionRequiredData(): Observable<any> {
    return this.http.get(this.routePrefix + "/get-required-data-for-claim-submission");
  }

  getNumberOfPendingClaims(): Observable<any> {
    return this.http.get(this.routePrefix + '/get-number-of-pending-claims')
  }

  ppoAdditionalDocumentSubmission(data): Observable<any> {
    return this.http.post(this.routePrefix + "/ppo-additional-document-submission", data);
  }

  getGmClaimFormDocument(): Observable<IFileExtend> {
    return this.http.get<IFileExtend>(`${this.routePrefix}/get-gm-claim-form-document`);
  }
  
  getGroupItemizedBillDocument(): Observable<IFileExtend> {
    return this.http.get<IFileExtend>(`${this.routePrefix}/get-group-itemized-bill-document`);
  }
}
